import { gql } from '@apollo/client';

export const GET_PRICES_LIST = gql`
  query listPricing($pricingDurationId: Int) {
    listPricings(filter: { pricing_duration_id: $pricingDurationId }) {
      id
      pricing_type {
        id
        title
      }
      pricing_duration {
        id
        title
      }
      title
      description
      features_heading
      features
      chargebee_plan_id
      enterprise
      chargebee_plan_info {
        price
        price_with_tax
        is_taxable
        max_team_members
        min_team_members
      }
      free_trial_period {
        count
        unit
      }
    }
  }
`;

export const GET_CHARGEBEE_PLAN_INFO = gql`
  query getPricing($chargeBeePlanId: String!) {
    getFilteredPricing(filter: { chargebee_plan_id: $chargeBeePlanId }) {
      chargebee_plan_id
      description
      enterprise
      id
      title
      chargebee_plan_info {
        max_team_members
        min_team_members
        price
        price_with_tax
        is_taxable
      }
      pricing_duration {
        id
        title
      }
      pricing_type {
        id
        title
      }
    }
  }
`;

export const GET_SUBSCRIPTION_INFO_THANK_YOU_PAGE = gql`
  query GetSubscriptionInfoThankYouPage{
    getSubscriptionInfoThankYouPage {
      type
      billing_starts
      invoice_link
      number_of_learners
      organization_name
      payment_frequency
      renews_automaticly_on
      total_price
      free_trial_period {
        count
        unit
      }
      subscription_group_type
    }
  }
`;
